//获取地址栏参数，key:参数名称
export function getParams(url) {
  // var url = window.location.search; //获取url中"?"符后的字串
  let theRequest = new Object();
  // 判断是否有多个参数
  if (url?.indexOf("&") != -1) {
    // 以&符分项组成数组
    let strs = url?.split("&");
    for (var i = 0; i < strs?.length; i++) {
      // 循环数组
      // theRequest[strs[i].split("=")[0]] = unescape(strs[i].split("=")[1]);
      // 每一项等号左边为属性，等号右边为属性的值，值需要使用 decodeURI() 函数对通过 escape() 或 url 编码过的字符串进行解码。
      theRequest[strs[i].split("=")[0]] = decodeURI(strs[i].split("=")[1]);
    }
  } else {
    // 只有一个参数
    let arr = url?.split("=");
    theRequest[arr[0]] = arr[1];
  }
  return theRequest;
}
// function getParam(name, defaultValue){
//   console.log(name)
//   console.log(defaultValue)
//   debugger
//   var query = window.location.search.substring(1);
//   var vars = query.split("&");
//   for (var i=0;i<vars.length;i++) {
//     var pair = vars[i].split("=");
//     if(pair[0] == name){return pair[1];}
//   }
//   return(defaultValue == undefined ? null : defaultValue);
// }
